import React from 'react'
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import kebabCase from 'lodash/kebabCase';

import './styles.scss';

const FolioNavigation = ({ thumbs, disableSlides, resetFolio, handleClick }) => {

  const handleSelection = (e, title) => {
    resetFolio();
    disableSlides();

    setTimeout(() => {
      setTimeout(() => {
        handleClick({ title: title })
      }, 10);
    }, 1000);
  };

  const sortedThumbs = thumbs && thumbs.sort((a,b) => (a.order > b.order) ? 1 : ((b.order > a.order) ? -1 : 0));
  const paths = sortedThumbs && sortedThumbs.map((thumbnail, index) => {
    return (
        thumbnail.enabled &&
      <NavLink activeClassName='is-active'
               to={ `/folio/${kebabCase(thumbnail.title)}`}
               onClick={ (e) => handleSelection(e, thumbnail.title)}
               src={ thumbnail.path.url }
               alt={ thumbnail.title }
               key={ index }
               className="media media--thumbnail"
      >
        <h2>{ thumbnail.title }</h2>
        <img onClick={ (e) => handleSelection(e, thumbnail.title)} src={ thumbnail.path.url } alt={ thumbnail.title } />
      </NavLink>
    );
  });

  return (
      <div className="c-folio-navigation">
        <div className="c-folio-navigation__nav">
          <span className="c-folio-navigation__title">Featured projects</span>
        </div>
        <div className="c-folio-navigation__thumbs">
          { paths }
        </div>
      </div>
  );
};


FolioNavigation.propTypes = {
  disableSlides: PropTypes.func.isRequired,
  handleClick: PropTypes.func.isRequired,
  resetFolio: PropTypes.func.isRequired,
  thumbs: PropTypes.array,
};


export default FolioNavigation;



// WEBPACK FOOTER //
// ./src/components/FolioNavigation/index.js